import { render, staticRenderFns } from "./PageEditForum.vue?vue&type=template&id=172a3222&scoped=true&"
import script from "./PageEditForum.vue?vue&type=script&lang=js&"
export * from "./PageEditForum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a3222",
  null
  
)

export default component.exports